import { Injectable } from '@angular/core';
import {
  BaseFpxFormHelper,
  BaseFpxComponentState,
} from 'src/app/common/utils/base-fpx.form.component';
import { RepaymentScheduleService } from './repayment-schedule.service';

export class RepaymentScheduleState extends BaseFpxComponentState {}

@Injectable()
export class RepaymentScheduleHelper extends BaseFpxFormHelper<RepaymentScheduleState> {
  constructor(private repaymentScheduleService: RepaymentScheduleService) {
    super(new RepaymentScheduleState());
  }

  public doConfirm(context: any, success: any, failure: any) {}

  public doSubmit(context: any, success: any, failure: any) {}
}
